/**
 * Do not edit directly
 * Generated on Tue, 04 Jul 2023 13:44:38 GMT
 */

export const DarkMode = {
  accent: {
    primary: {
      strong: "rgba(255, 198, 0, 1)",
      medium: "rgba(184, 138, 0, 1)",
      subtle: "rgba(125, 91, 0, 1)",
    },
    secondary: {
      strong: "rgba(0, 151, 169, 1)",
      medium: "rgba(0, 107, 123, 1)",
      subtle: "rgba(0, 58, 68, 1)",
    },
    tertiary: {
      strong: "rgba(51, 96, 148, 1)",
      medium: "rgba(32, 75, 122, 1)",
      subtle: "rgba(16, 53, 92, 1)",
    },
  },
  background: {
    surface: "rgba(41, 41, 41, 1)",
    raised: "rgba(52, 52, 52, 1)",
    base: "rgba(28, 28, 28, 1)",
    section: "rgba(255, 255, 255, 0.09)",
    inactive: "rgba(255, 255, 255, 0.03)",
    inverted: "rgba(224, 224, 224, 1)",
    mask: "rgba(28, 28, 28, 0.14)",
  },
  border: {
    strong: "rgba(255, 255, 255, 0.75)",
    medium: "rgba(255, 255, 255, 0.35)",
    subtle: "rgba(255, 255, 255, 0.09)",
  },
  text: {
    onSurface: {
      strong: "rgba(255, 255, 255, 0.99)",
      subtle: "rgba(255, 255, 255, 0.49)",
      inactive: "rgba(255, 255, 255, 0.19)",
      link: "rgba(0, 151, 169, 1)",
      hover: "rgba(0, 107, 123, 1)",
      visited: "rgba(195, 158, 201, 1)",
      positive: "rgba(0, 133, 87, 1)",
      negative: "rgba(221, 29, 33, 1)",
      warning: "rgba(255, 177, 91, 1)",
      information: "rgba(75, 120, 170, 1)",
    },
    onInverted: {
      strong: "rgba(52, 52, 52, 1)",
      subtle: "rgba(74, 74, 74, 1)",
      inactive: "rgba(192, 192, 192, 1)",
      link: "rgba(75, 120, 170, 1)",
      hover: "rgba(110, 148, 192, 1)",
      visited: "rgba(132, 75, 142, 1)",
    },
    onPrimary: {
      strong: "rgba(52, 52, 52, 1)",
      subtle: "rgba(74, 74, 74, 1)",
      inactive: "rgba(28, 28, 28, 0.28)",
      link: "rgba(52, 52, 52, 1)",
    },
    onSecondary: {
      strong: "rgba(255, 255, 255, 1)",
      subtle: "rgba(28, 28, 28, 0.94)",
      inactive: "rgba(28, 28, 28, 0.38)",
      link: "rgba(28, 28, 28, 0.8)",
    },
    onTertiary: {
      strong: "rgba(255, 255, 255, 1)",
      subtle: "rgba(255, 255, 255, 0.92)",
      inactive: "rgba(255, 255, 255, 0.26)",
      link: "rgba(255, 255, 255, 1)",
    },
    onFocus: {
      strong: "rgba(255, 255, 255, 1)",
      subtle: "rgba(28, 28, 28, 0.94)",
      inactive: "rgba(28, 28, 28, 0.38)",
      link: "rgba(28, 28, 28, 0.8)",
    },
    onBase: {
      strong: "rgba(255, 255, 255, 0.99)",
      subtle: "rgba(255, 255, 255, 0.49)",
      inactive: "rgba(255, 255, 255, 0.19)",
      link: "rgba(0, 151, 169, 1)",
      hover: "rgba(0, 107, 123, 1)",
      visited: "rgba(195, 158, 201, 1)",
    },
    onSystem: {
      strong: {
        neutral: "rgba(255, 255, 255, 1)",
        positive: "rgba(255, 255, 255, 1)",
        negative: "rgba(255, 255, 255, 1)",
        warning: "rgba(52, 52, 52, 1)",
        information: "rgba(255, 255, 255, 1)",
      },
      subtle: {
        neutral: "rgba(192, 192, 192, 1)",
        positive: "rgba(151, 205, 175, 1)",
        negative: "rgba(255, 172, 160, 1)",
        warning: "rgba(255, 218, 174, 1)",
        information: "rgba(143, 173, 209, 1)",
      },
    },
  },
  system: {
    strong: {
      neutral: "rgba(117, 117, 117, 1)",
      positive: "rgba(0, 133, 87, 1)",
      negative: "rgba(221, 29, 33, 1)",
      warning: "rgba(255, 177, 91, 1)",
      information: "rgba(75, 120, 170, 1)",
    },
    subtle: {
      neutral: "rgba(74, 74, 74, 1)",
      positive: "rgba(0, 60, 33, 1)",
      negative: "rgba(111, 0, 0, 1)",
      warning: "rgba(84, 40, 0, 1)",
      information: "rgba(16, 53, 92, 1)",
    },
  },
  focus: {
    strong: "rgba(0, 151, 169, 1)",
    medium: "rgba(0, 131, 148, 0.78)",
    subtle: "rgba(86, 185, 200, 0.33)",
    extraSubtle: "rgba(0, 151, 168, 0.1)",
  },
  series: {
    1: "rgba(0, 151, 169, 1)",
    2: "rgba(51, 96, 148, 1)",
    3: "rgba(154, 96, 164, 1)",
    4: "rgba(221, 29, 33, 1)",
    5: "rgba(237, 138, 0, 1)",
    6: "rgba(255, 198, 0, 1)",
    7: "rgba(160, 201, 99, 1)",
    8: "rgba(0, 133, 87, 1)",
    9: "rgba(129, 204, 217, 1)",
    10: "rgba(110, 148, 192, 1)",
    11: "rgba(195, 158, 201, 1)",
    12: "rgba(255, 136, 123, 1)",
    13: "rgba(255, 218, 174, 1)",
    14: "rgba(255, 223, 85, 1)",
    15: "rgba(201, 236, 154, 1)",
    16: "rgba(111, 185, 147, 1)",
  },
  elevation: {
    level0: "0px 1px 3px rgba(0, 0, 0, 0.28), 0px 0px 1px rgba(0, 0, 0, 0.2)",
    level1: "0px 2px 5px rgba(0, 0, 0, 0.28), 0px 0px 2px rgba(0, 0, 0, 0.2)",
    level2: "0px 6px 24px rgba(0, 0, 0, 0.28), 0px 2px 6px rgba(0, 0, 0, 0.2)",
    level3:
      "0px 10px 40px rgba(0, 0, 0, 0.32), 0px 4px 12px rgba(0, 0, 0, 0.2)",
    level4:
      "0px 20px 64px rgba(0, 0, 0, 0.2), 0px 16px 24px rgba(0, 0, 0, 0.28)",
    level5:
      "0px 24px 80px rgba(0, 0, 0, 0.2), 0px 16px 32px rgba(0, 0, 0, 0.36)",
  },
};
